/* eslint-disable react/no-danger */
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import { IconButton, MenuItem, Menu } from '@material-ui/core';
import routePaths from '../../routePaths';

class UserInfoPanel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      anchor: undefined,
      open: false,
    };
    
    this.handleMenuClick = this.handleMenuClick.bind(this);
    this.handleMenuRequestClose = this.handleMenuRequestClose.bind(this);
    this.handleSignOut = this.handleSignOut.bind(this);
  }

  handleMenuClick(event) {
    this.setState({
      open: true,
      anchor: event.currentTarget,
    });
  }

  handleMenuRequestClose() {
    this.setState({
      open: false,
    });
  }

  handleSignOut() {
    const returnTo = encodeURIComponent(location.pathname + (location.hash ? location.hash : ''));
    this.props.authActions.signOut(returnTo);
  }

  render() {
    const returnTo = encodeURIComponent(location.pathname + (location.hash ? location.hash : ''));
    return (
      <React.Fragment>
        {this.props.auth.signedIn && this.props.account
          ? <div className="user-actions">
              Zalogowany <Link to={routePaths.userProfile}>{this.props.account.firstName} {this.props.account.lastName}</Link> <a style={{display: 'none'}} onClick={this.props.authActions.signOut}>Wyloguj</a>
              <IconButton
                onClick={this.handleMenuClick}
                aria-label="Open profile menu"
                aria-owns={this.state.open ? 'profile-menu' : null}
                aria-haspopup="true"
              >
                <MoreVertIcon />
              </IconButton>
              <Menu
                id="profile-menu"
                anchorEl={this.state.anchor}
                open={this.state.open}
                onClose={this.handleMenuRequestClose}
              >
                <MenuItem
                  key="ok"
                  onClick={this.handleSignOut}
                >Wyloguj się</MenuItem>
              </Menu>
            </div>
          : this.props.authenticationRequired
            ? <div className="user-actions"><Link className="btn" to={`${routePaths.signIn}?returnTo=${returnTo}`}>Zaloguj się</Link> <Link className="btn" to={`${routePaths.registration}?returnTo=${returnTo}`}>Zarejestruj konto</Link></div>
            : null}
      </React.Fragment>
    );
  }
}

UserInfoPanel.propTypes = {
  authActions: PropTypes.object.isRequired,
  authenticationRequired: PropTypes.bool,
  auth: PropTypes.object,
  account: PropTypes.object,
};

export default UserInfoPanel;



// WEBPACK FOOTER //
// ./src/components/auth/UserInfoPanel.js